<template>
    <DownloadOptionWrapper tooltip="You can choose to manually specify the video length">
        <Checkbox v-model="duration.enabled" data-testid="download-video-runtime-checkbox">
            <h4>Video runtime</h4>
        </Checkbox>
        <template #input>
            <Input v-model="duration.value" placeholder="0.00" data-testid="download-video-runtime-value">
                <template #append>
                    <span>sec</span>
                </template>
            </Input>
        </template>
    </DownloadOptionWrapper>

    <DownloadOptionWrapper tooltip="You can choose to manually specify the video framerate">
        <Checkbox v-model="manualFps.enabled" data-testid="download-modal__download-video-fps-checkbox">
            <h4>Frame rate</h4>
        </Checkbox>
        <template #input>
            <Select v-model="manualFps.value" size="small" data-testid="download-modal__download-video-fps-select">
                <Option
                    v-for="option in FPS_OPTIONS"
                    :key="option"
                    :value="option"
                    :data-testid="`download-modal__download-video-fps-select-${option}`"
                >
                    {{ option }}
                </Option>
            </Select>
        </template>
    </DownloadOptionWrapper>

    <DownloadOptionWrapper tooltip="Capture audio from the template and include it in the output video">
        <Checkbox v-model="captureAudio" data-testid="download-modal__capture-audio-checkbox">
            <h4>Capture Audio</h4>
        </Checkbox>
    </DownloadOptionWrapper>

    <DownloadOptionWrapper tooltip="You can then re-encode into another format manually">
        <Checkbox v-model="highQuality" data-testid="download-modal__high-quality-checkbox">
            <h4>Export as uncompressed</h4>
        </Checkbox>
    </DownloadOptionWrapper>

    <DownloadOptionWrapper
        tooltip="Useful when the banner contains a video with the same fps as the output. Note that it will make the video
        generation slower."
    >
        <Checkbox v-model="optimisedVideoFrames" data-testid="download-modal__optimise-video-frames-checkbox">
            <h4>Optimise Video Frames</h4>
        </Checkbox>
    </DownloadOptionWrapper>
</template>

<script lang="ts" setup>
import { useDownloadHTMLVideo } from "@/composables/download/useDownloadHTMLVideo";
import DownloadOptionWrapper from "@/components/Download/DownloadOptionWrapper.vue";
import { FPS_OPTIONS } from "@/components/Download/consts";

const { duration, manualFps, captureAudio, highQuality, optimisedVideoFrames } = useDownloadHTMLVideo();
</script>
